import React, { useEffect, useState } from 'react';

// bootstrap
import { Form } from 'react-bootstrap';

// styling
import { Colors, Spacing } from '_styles';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectTableNumber, setTableNumber, setManuallySet } from '_redux/slices/marketplace/user-marketplace';

const ChangeTableModal = (props) => {

    // redux
    const dispatch = useDispatch();

    const tableNumber = useSelector(selectTableNumber);

    const [originalTableNumber, setOriginalTableNumber] = useState(tableNumber);
    const [newTableNumber, setNewTableNumber] = useState('');

    useEffect(() => {
        // set intial table number
        if(tableNumber){
            setOriginalTableNumber(tableNumber);
            setNewTableNumber(tableNumber)
        }
    }, []);

    const handleDone = () => {
        if (newTableNumber !== tableNumber) {
            dispatch(setTableNumber(newTableNumber));
            dispatch(setManuallySet(true));
        }
        props.done();
    }


    return (
        <div style={{ padding: Spacing.SCALE_12 }}>

            {/* Header and Close Button */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: Spacing.SCALE_16,
            }}>
                <h5 style={{ margin: 0, fontWeight: 'bold', fontSize: 18 }}>Change Table Number</h5>
                <button
                    onClick={handleDone}
                    style={{
                        background: 'none',
                        border: 'none',
                        fontSize: 24,
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        color: '#888',
                        lineHeight: 1,
                    }}
                    aria-label="Close modal"
                >
                    &times;
                </button>
            </div>

            <Form.Label className="fw-semibold">Table Number</Form.Label>
            <Form.Control
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                value={newTableNumber}
                onChange={(e) => {
                    const val = e.target.value;
                    if (/^\d*$/.test(val)) {
                        setNewTableNumber(val);
                    }
                }}
            />

            {/* buttons */}
            <button onClick={handleDone} className="mt-2 btn btn-success" style={{ backgroundColor: Colors.PRM_LIGHT_BLUE, justifyContent: 'center', width: '100%' }}>
                {originalTableNumber == newTableNumber ? 'Yes, thats my table number' : 'Change Table Number'}
            </button>

        </div>
    );
};

export default ChangeTableModal;
